import home_about_img from "../../../assets/img/HomePage/Mobile/home_about_img.jpg";
import { homeAboutContent } from "../../HomePage/content";
import HomeAboutStoryBody from "../../HomePage/HomeAboutStoryBody";

const HomeAbout = () => {
  return (
    <section className="pb-[40px] bg-[#F8F8F8]">
      <div className="relative w-full">
        {/* Image Box */}
        <div className="h-[40px] bg-primaryDark-400"></div>
        <img
          src={home_about_img}
          alt={homeAboutContent.imageAlt}
          className="w-full object-cover"
        />

        {/* Text Box */}
        <div className="px-[20px] mt-[-55px] relative z-[10]">
          <div className="bg-text-1000 shadow-md shadow-text-0/24 rounded-[8px] px-[32px] py-[24px] ">
            <p className="text-[16px] font-open-sans font-bold text-primaryDark-0 mb-[8px]">
              {homeAboutContent.eyebrow}
            </p>

            <h4 className="text-[24px] font-raleway font-bold leading-tight text-primaryDark-0 mb-4">
              <span className="text-primaryDark-400">
                {" "}
                {homeAboutContent.titleHighlight}{" "}
              </span>
              {homeAboutContent.titleRest}
            </h4>

            <HomeAboutStoryBody bodyClassName="text-[15px] font-open-sans text-text-0 leading-[1.65]" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeAbout;
